export interface RequestHotelRecentlyViewInterface {
  id: string[];
  checkin?: string;
  checkout?: string;
}

export interface ResponseHotelRecentlyView {
  id: number;
  name: string;
  areaName: string;
  cityName: string;
  isActive: number;
  slug: string;
  textRating: string;
  countryName?: string;
  isGreenCertificate?: string;
  reviewRating: {
    numReviews: number;
    rating: number;
    textRatingDetail: string;
  };
  isFavorite: boolean;
  specialDeal: boolean;
  recommend: boolean;
}

export class ResponseHotelRecentlyView {
  id: number;

  name: string;

  areaName: string;

  cityName: string;

  isActive: number;

  slug: string;

  textRating: string;

  countryName?: string;

  isGreenCertificate?: string;

  reviewRating: {
    numReviews: number;
    rating: number;
    textRatingDetail: string;
  };

  isFavorite: boolean;

  specialDeal: boolean;

  recommend: boolean;

  perk: string = "";

  constructor(data: any) {
    this.id = data?.id || 0;
    this.name = data?.name || "";
    this.areaName = data?.areaName || "";
    this.cityName = data?.cityName || "";
    this.isActive = data?.isActive || 0;
    this.slug = data?.slug || "";
    this.textRating = data?.textRating || "";
    this.countryName = data?.countryName || "";
    this.isGreenCertificate = data?.isGreenCertificate || "";
    this.reviewRating = {
      numReviews: data.reviewRating?.numReviews || 0,
      rating: data.reviewRating?.rating || 0,
      textRatingDetail: data.reviewRating?.textRatingDetail || "",
    };
    this.isFavorite = data?.isFavorite || false;
    this.specialDeal = data?.specialDeal || false;
    this.recommend = data?.recommend || false;
    this.perk = data?.perk ?? data?.perks ?? this.perk;
  }
}
